import { render, staticRenderFns } from "./CreateNewMessageModal.vue?vue&type=template&id=31151888"
import script from "./CreateNewMessageModal.vue?vue&type=script&lang=js"
export * from "./CreateNewMessageModal.vue?vue&type=script&lang=js"
import style0 from "./CreateNewMessageModal.vue?vue&type=style&index=0&id=31151888&prod&lang=scss"
import style1 from "./CreateNewMessageModal.vue?vue&type=style&index=1&id=31151888&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports